<template>
  <v-combobox
    chips
    :disabled="field.readonly"
    :error-messages="errors"
    :hide-details="dense"
    :model-value="modelValue"
    :multiple="field.multiple"
    :rules="rules"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #label>
      <FieldLabel :field="field" />
    </template>
  </v-combobox>
</template>

<script setup lang="ts">
defineProps<{
  field: FieldConfig
  modelValue: string | string[]
  errors?: string[]
  dense?: boolean
  rules?: FormRule[]
}>();
defineEmits(['update:modelValue']);
</script>
